<template xmlns="http://www.w3.org/1999/html">
  <hm-content title="">
    <div class="flex flex-between item-center">
      <el-radio-group
        class="mb10"
        size="small"
        v-model="switchType"
        @change="switchTab"
      >
        <el-radio-button label="rule">规则设置</el-radio-button>
        <el-radio-button label="detail">明细查询</el-radio-button>
      </el-radio-group>
    </div>
    <div class="mt20" v-if="switchType === 'rule'">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="130px"
      >
        <div>
          <el-form-item label="奖励规则" prop="rewardType">
            <el-radio-group
              v-model="ruleForm.rewardType"
              @change="switchRewardType"
            >
              <el-radio label="loop">循环奖励</el-radio>
              <el-radio label="step"
                >阶梯奖励
                <span v-if="ruleForm.rewardType === 'step'"
                  >(推荐数量请从小到大填写)</span
                ></el-radio
              >
            </el-radio-group>
          </el-form-item>
          <el-form-item label="推荐会员门槛" prop="thresholdMode">
          <el-radio-group
              v-model="ruleForm.thresholdMode"
          >
            <el-radio label="noLimit"
            >不限制</el-radio
            >
            <el-radio label="limit"
            >限制</el-radio
            >
          </el-radio-group>
          <div class="flex" v-if="ruleForm.thresholdMode==='limit'">
            <span>注册</span>
            <el-form-item prop="registerDay">
               <el-input
                size="small"
                clearable
                class="ml10 mr10 ipt"
                maxlength="18"
                style="width: 120px"
                v-model.trim="ruleForm.registerDay"
                placeholder="请输入天数"
            ></el-input>
            </el-form-item>
           
            <span>天内，累计消费金额超过</span>
            <el-form-item prop="registerMoney">
              <el-input
                size="small"
                clearable
                class="ml10 mr10 ipt"
                maxlength="18"
                style="width: 120px"
                v-model.trim="ruleForm.registerMoney"
                placeholder="请输入金额"
            ></el-input>
            </el-form-item>
            
            <span>元（满足此条件的注册会员，推荐人才会获得奖励)</span>
          </div>
        </el-form-item>
          <el-form-item label="设置奖励" prop="ruleInfo">
            <div
              v-for="(v, i) in ruleForm.ruleInfo"
              :key="i"
              v-show="isShowRuleInfo"
            >
              <div class="mb10 flex">
                <div>
                  <span class="mr20">推荐注册</span>
                  <span v-if="ruleForm.rewardType === 'loop'">人数每达到</span>
                  <span v-if="ruleForm.rewardType === 'step' && i === 0"
                    >人数达到</span
                  >
                  <span v-if="ruleForm.rewardType === 'step' && i !== 0"
                    >人数再达到</span
                  >
                  <el-input
                    size="small"
                    clearable
                    class="ml10 mr10 ipt"
                    maxlength="18"
                    style="width: 200px"
                    v-model.trim="v.regCount"
                    placeholder="请输入推荐人的数量"
                  ></el-input>
                </div>
                <div v-if="ruleForm.rewardType === 'loop'">
                  <span>循环次数</span>
                  <el-input
                    size="small"
                    clearable
                    class="ml10 mr10 ipt"
                    maxlength="18"
                    style="width: 200px"
                    v-model.trim="v.loopCount"
                    placeholder="请输入循环次数"
                  ></el-input>
                </div>
                <div
                  class="flex flex-center item-center"
                  v-if="ruleForm.rewardType === 'step'"
                >
                  <div
                    style="margin-left: 0px"
                    class="add-wrapper flex flex-center"
                    v-if="i === 0"
                  >
                    <span
                      class="hmicon icon-hao pointer"
                      @click="addChild()"
                    ></span>
                  </div>
                  <div
                    style="margin-left: 0px"
                    class="minus-wrapper flex flex-center"
                    v-else
                  >
                    <span
                      class="hmicon icon-jianhao pointer"
                      @click="deleteChild(i)"
                    ></span>
                  </div>
                </div>
              </div>
              <div class="mb10">
                <span class="mr20">奖励类型</span>
                <!-- <span>积分</span>
                <el-input
                  size="small"
                  clearable
                  class="ml10 mr10 ipt"
                  maxlength="18"
                  style="width: 120px"
                  v-model.trim="v.integral"
                  placeholder="请输入积分"
                ></el-input> -->
                <span>优惠券</span>
                <el-select
                  size="small"
                  class="ml10 mr10"
                  clearable
                  placeholder="请选择奖励券包"
                  filterable
                  v-model="v.couponRuleSendId"
                >
                  <el-option
                    :label="item.name"
                    :value="item.couponSendId"
                    v-for="(item, index) in couponList"
                    :key="index"
                  ></el-option>
                </el-select>
                <span class="red">(不填信息就无相关奖励类型)</span>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="规则状态" prop="rewardSwitch">
            <el-switch
              v-model="ruleForm.rewardSwitch"
              active-color="#2d8"
              inactive-color="#ff4949"
              active-text="开启"
              inactive-text="关闭"
              active-value="opend"
              inactive-value="close"
            ></el-switch>
          </el-form-item>
        </div>
      </el-form>
      <div class="btn-wrapper flex flex-center mt20">
        <el-button
          @click="submitRuleForm('ruleForm')"
          size="small"
          type="primary"
          >保存</el-button
        >
        <el-button type="info" size="small" @click="queryInvitationLoad()"
          >重置</el-button
        >
      </div>
    </div>

    <div class="mt20" v-if="switchType === 'detail'">
      <el-table
        stripe
        border
        :data="recommendedList"
        style="width: 100%"
        id="table"
        size="small"
      >
        <el-table-column
          header-align="center"
          align="center"
          type="index"
          label="序号"
          :index="(index) => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="invitationPhone"
          label="推荐会员手机号"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="invitationName"
          label="推荐会员姓名"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="invitationCount"
          label="邀请人数"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="categoryName"
          label="操作"
        >
          <template slot-scope="scope">
            <div class="flex flex-center item-center">
              <el-button
                type="text"
                class="blue"
                size="small"
                @click="details(scope.row)"
                >查看</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="hm-pagination mb20">
        <el-pagination
          background
          :total="total"
          @current-change="paging"
          @size-change="handleSizeChanges"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="currentPage"
        ></el-pagination>
      </div>

      <el-dialog
        title="查看详情"
        :close-on-click-modal="false"
        :visible.sync="dialogVisible"
      >
        <el-table
          stripe
          border
          class="mb20"
          ref="brandTable"
          :data="detailsList"
          style="width: 100%"
          id="table"
          size="small"
        >
          <el-table-column
            header-align="center"
            align="center"
            type="index"
            label="序号"
            :index="
              (index) => index + (currentPageDetails - 1) * pageSizeDetails + 1
            "
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="beInvitationPhone"
            label="邀请人手机号"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="beInvitationName"
            label="邀请人姓名"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="createTime"
            label="邀请时间"
          ></el-table-column>
          <!-- <el-table-column
            header-align="center"
            align="center"
            prop="rewardCoupon"
            label="邀请奖励"
          >
          <template slot-scope="scope">
            <div v-if="scope.row.rewardCoupon">优惠券:{{scope.row.rewardCoupon}}</div>
            <div v-if="scope.row.rewardIntegral">积分:{{scope.row.rewardIntegral}}</div>
          </template>
          </el-table-column> -->
        </el-table>
        <div class="hm-pagination mb20">
          <el-pagination
            background
            :total="totalDetail"
            @current-change="pagingDetail"
            @size-change="handleSizeChangesDetail"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="currentPage"
          ></el-pagination>
        </div>
        <div class="flex flex-center">
          <el-button size="small" @click="dialogVisible = false"
            >关闭</el-button
          >
        </div>
      </el-dialog>
    </div>
  </hm-content>
</template>

<script>
import HmFilterMicroShopGoods from "@/components/HmFilterMicroShopGoods";
import { mapGetters } from "vuex";
import HmFilterGroupGoods from "@/components/HmFilterGroupGoods";
import HmUpload from "@/components/HmUpload";
import { getLoginUser } from "@/utils/auth";

export default {
  components: {
    HmFilterMicroShopGoods,
    HmFilterGroupGoods,
    HmUpload,
  },
  data() {
    const ruleInfoAll = (rule, val, callback) => {
    if (this.ruleForm.ruleInfo) {
        let isHaveRegCount = true;
        let isInteger = true;
        let isIncreasing = true;

        this.ruleForm.ruleInfo.forEach((v, index, arr) => {
            if (!v.regCount) {
                isHaveRegCount = false;
            }
            if (!Number.isInteger(Number(v.regCount))) {
                isInteger = false;
            }
            if (index > 0 && arr[index].regCount <= arr[index - 1].regCount) {
                isIncreasing = false;
            }
        });

        if (!isHaveRegCount) {
            return callback(new Error("请输入推荐人的数量"));
        }
        if (!isInteger) {
            return callback(new Error("推荐人的数量必须为整数"));
        }
        if (!isIncreasing) {
            return callback(new Error("推荐人的数量必须后一项大于前一项"));
        }
    }
    callback();
  };
    const patternAll = (rule, val, callback) => {
      if (val === "all") {
        if (
          !this.ruleForm.rewardIntergalValue &&
          !this.ruleForm.rewardCouponSendValue
        ) {
          return callback(new Error("请填写"));
        }
      }

      callback();
    };
    const patternList = (rule, val, callback) => {
      let row = this.ruleForm.basicRewardConfig.regConfigVoList.find(
        (v) => v.fillingKeyName === val
      );
      if (
        row.checked &&
        !row.rewardIntergalValue &&
        !row.rewardCouponSendValue
      ) {
        return callback(new Error("请填写"));
      }
      callback();
    };
    return {
      type: "",
      row: {},
      switchType: "rule",
      currentPage: 1,
      currentPageDetails: 1,
      pageSize: 10,
      pageSizeDetails: 10,
      total: 0,
      totalDetail: 0,
      isShowRuleInfo: true,
      ruleForm: {
        rewardType: "loop",
        rewardSwitch: "opend",
        ruleInfo: [
          {
            regCount: "",
            loopCount: "",
            integral: "",
            couponRuleSendId: "",
          },
        ],
        thresholdMode: "noLimit",
        registerDay: "",
        registerMoney: "",
      },
      rules: {
        fillingKeyName: [{ validator: patternList }],
        all: [{ validator: patternAll }],
        ruleInfo: [{ validator: ruleInfoAll }],
        // thresholdMode:[{validator: thresholdModeAll}],
        registerDay:[{
            required: true,
            pattern: /^([1-9]\d*|[0]{1,1})$/,
            message: "请输入正确天数",
            trigger: "blur",
          }],
        registerMoney: [{
            required: true,
            pattern: /^\d+(\.\d{1,2})?$/,
            message: "请输入有效的金额",
            trigger: "blur",
          }]
      },
      couponList: [],
      recommendedList: [],
      detailsList: [],
      dialogVisible: false,
    };
  },
  computed: {
    ...mapGetters(["microShopRouteList"]),
  },
  watch: {},
  created() {
    this.queryCouponList();
    this.queryInvitationLoad();
  },
  mounted() {},
  methods: {
    details(row) {
      this.row = row;
      console.log("this.row:",this.row);
      this.queryBeInvitations();
      this.dialogVisible = true;
    },
    paging(page) {
      this.currentPage = page;
      this.queryInvitations();
    },
    handleSizeChanges(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryInvitations();
    },
    pagingDetail(page) {
      this.currentPageDetail = page;
      this.queryBeInvitations();
    },
    handleSizeChangesDetail(size) {
      this.currentPageDetail = 1;
      this.pageSizeDetail = size;
      this.queryBeInvitations();
    },
    switchTab(v) {      
      if(v==='rule'){
        this.queryInvitationLoad();
      }else if(v==='detail'){
        this.queryInvitations();
      }
    },
    switchRewardType() {
      this.ruleForm.ruleInfo = [
        {
          regCount: "",
          loopCount: "",
          integral: "",
          couponRuleSendId: "",
        },
      ];
    },
    addChild() {
      this.ruleForm.ruleInfo.push({
        regCount: "",
        loopCount: "",
        integral: "",
        couponRuleSendId: "",
      });
    },
    deleteChild(index) {
      this.ruleForm.ruleInfo.splice(index, 1);
    },
    async queryCouponList() {
      const { code, result } = await this.$store.dispatch(
        "findCouponSendByEvent",
        {
          event: "activity",
        }
      );
      if (code === "0") {
        this.couponList = result;
      }
    },
    async queryInvitationLoad() {
      const { storeCode } = getLoginUser();
      let params = {
        storeCode
      };
      const { code, result } = await this.$store.dispatch("queryInvitationLoad",params);
      if (code === "0") {
        if (result) {
          this.type = "edit";
          if (result.ruleInfo) {
            result.ruleInfo = JSON.parse(result.ruleInfo);
            console.log(result.ruleInfo);
          }
          this.ruleForm = result;
        } else {
          this.type = "add";
        }
        this.isShowRuleInfo = true;
        console.log("this.type:", this.type);
      }
    },
    async queryInvitations(){
      let params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
      };
      const { code, result } = await this.$store.dispatch("queryInvitations",params);
      if (code === "0") {
        this.recommendedList = result.records;
        this.total = result.total;
        console.log("this.recommendedList",this.recommendedList);
      }
    },
    async queryBeInvitations(){
      const { storeCode } = getLoginUser();
      console.log("this.row.invitationCenterId",this.row.invitationCenterId);
      let params = {
        pageSize: this.pageSizeDetails,
        pageNo: this.currentPageDetails,
        invitationCenterId: this.row.invitationCenterId,
        storeCode
      };
      const { code, result } = await this.$store.dispatch("queryBeInvitations",params);
      if (code === "0") {
        console.log("result",result);
        this.detailsList = result.records;
        this.totalDetail = result.total;
      }
    },
    submitRuleForm(formName) {
      console.log("this.ruleForm", this.ruleForm);
      // return false;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.isShowRuleInfo = false;
          this.ruleForm.ruleInfo = JSON.stringify(this.ruleForm.ruleInfo);
          const params = JSON.parse(JSON.stringify(this.ruleForm));
          console.log("params:", params);
          let name = this.type === "add" ? "queryInvitationAdd" : "queryInvitationEdit";
          this.$store.dispatch(name, params).then((res) => {
            if (res.code === "0") {
              this.$message({
                message: res.inMsg,
                type: "success",
              });
              this.queryInvitationLoad();
            } else {
              this.$message({
                message: res.errMsg,
                type: "warning",
              });
              this.queryInvitationLoad();
            }
          });
        }
      });
    },
    back() {
      this.$router.back(-1);
    },
  },
};
</script>
<style lang='scss' scoped>
.red {
  color: #e50065;
}
</style>
